



import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";

function formatINR(paiseOrAmount) {
  try {
    const amount = Number(paiseOrAmount || 0) / 100;
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }).format(amount);
  } catch (error) {
    console.log("formatINR error:", error);
    return `₹${paiseOrAmount || 0}`;
  }
}

function Planone() {
  const [allplandata, setAllPlanData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [userData, setUserData] = useState(null);
  const [razorpayKeyId, setRazorpayKeyId] = useState("");

  const [allcoupondata, setAllCouponData] = useState([]);
  const [usedCoupons, setUsedCoupons] = useState([]);

  const [show, setShow] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const [searchvalue, setSearchValue] = useState("");
  const [couponError, setCouponError] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [processing, setProcessing] = useState(false);

  const API_LOCAL = "https://api.proleverageadmin.in";
  const PAYMENT_BASE = "https://api.proleverageadmin.in";

  const selectedPlanAmountPaise = useMemo(() => {
    try {
      return Number(selectedPlan?.item?.amount || 0);
    } catch (error) {
      console.log("selectedPlanAmountPaise error:", error);
      return 0;
    }
  }, [selectedPlan]);

  const handleClose = () => {
    try {
      setShow(false);
      setSelectedPlan(null);
      setSearchValue("");
      setCouponError("");
      setCouponApplied(false);
      setProcessing(false);
    } catch (error) {
      console.log("handleClose error:", error);
    }
  };

  const handleShow = () => {
    try {
      setShow(true);
    } catch (error) {
      console.log("handleShow error:", error);
    }
  };



  const fetchAllPlanData = async () => {
    try {
      setLoading(true);
      setErrMsg("");

      const res = await axios.get(`${API_LOCAL}/api/payment/getallbyplans`);

      const raw = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.items)
          ? res.data.items
          : [];

      // ✅ show only this default plan in Planone page
      const DEFAULT_PLAN_ID = "plan_ScvmZovQnGpLg9";

      const defaultPlan = raw.find(
        (plan) => plan?.id === DEFAULT_PLAN_ID && Boolean(plan?.item?.active)
      );

      setAllPlanData(defaultPlan ? [defaultPlan] : []);
    } catch (error) {
      console.log("fetchAllPlanData error:", error);
      setErrMsg(
        error?.response?.data?.message || "Failed to load plans. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // const fetchAllPlanData = async () => {
  //   try {
  //     setLoading(true);
  //     setErrMsg("");

  //     const res = await axios.get(`${API_LOCAL}/api/payment/getallbyplans`);

  //     const raw = Array.isArray(res.data)
  //       ? res.data
  //       : Array.isArray(res.data?.items)
  //         ? res.data.items
  //         : [];

  //     const onlyActivePlans = raw.filter((plan) => Boolean(plan?.item?.active));

  //     // ✅ show only [0] index plan
  //     const firstPlan = onlyActivePlans[0] ? [onlyActivePlans[0]] : [];

  //     setAllPlanData(firstPlan);
  //   } catch (error) {
  //     console.log("fetchAllPlanData error:", error);
  //     setErrMsg(
  //       error?.response?.data?.message || "Failed to load plans. Please try again."
  //     );
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  console.log("allplandata", allplandata);

  const loadRazorpayScriptOnce = () => {
    try {
      return new Promise((resolve) => {
        if (window.Razorpay) {
          resolve(true);
          return;
        }

        const existing = document.querySelector(
          'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
        );

        if (existing) {
          existing.onload = () => resolve(true);
          existing.onerror = () => resolve(false);
          return;
        }

        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
      });
    } catch (error) {
      console.log("loadRazorpayScriptOnce error:", error);
      return Promise.resolve(false);
    }
  };

  const fetchPaymentKey = async () => {
    try {
      const res = await axios.get(
        `${PAYMENT_BASE}/api/paymentkey/getAllreazorpaypayment`
      );

      if (res.status === 200) {
        setRazorpayKeyId(res.data?.reazorpaykey_id || "");
      }
    } catch (error) {
      console.log("fetchPaymentKey error:", error);
    }
  };

  const getAllcoupondata = async () => {
    try {
      const res = await axios.get(`${PAYMENT_BASE}/api/getAllplanCoupon`);
      setAllCouponData(res.data?.data || []);
    } catch (error) {
      console.log("getAllcoupondata error:", error);
    }
  };

  const fetchUsedCoupons = async (userId) => {
    try {
      if (!userId) return;

      const res = await axios.get(
        `${PAYMENT_BASE}/api/users/getUserDetails/${userId}`
      );

      if (res.status === 200) {
        setUsedCoupons(res.data?.usedCoupons || []);
      }
    } catch (error) {
      console.log("fetchUsedCoupons error:", error);
    }
  };

  useEffect(() => {
    try {
      fetchAllPlanData();
      fetchPaymentKey();
      getAllcoupondata();

      const userdata = localStorage.getItem("user");

      if (userdata) {
        const parsed = JSON.parse(userdata);
        setUserData(parsed);
        fetchUsedCoupons(parsed?._id);
      }
    } catch (error) {
      console.log("useEffect error:", error);
    }
  }, []);

  const onSubscribe = (plan) => {
    try {
      setSelectedPlan(plan);
      setSearchValue("");
      setCouponError("");
      setCouponApplied(false);
      setProcessing(false);
      handleShow();
    } catch (error) {
      console.log("onSubscribe error:", error);
    }
  };

  const applyCoupon = () => {
    try {
      const code = (searchvalue || "").trim();

      if (!code) {
        setCouponError("❌ Enter coupon code");
        setCouponApplied(false);
        return;
      }

      if (!selectedPlan) {
        setCouponError("❌ Please select a plan");
        setCouponApplied(false);
        return;
      }

      if (usedCoupons.includes(code)) {
        setCouponError("❌ Coupon Code Already Used");
        setCouponApplied(false);
        return;
      }

      const planName =
        selectedPlan?.item?.name || selectedPlan?.notes?.plan_name || "";

      const found = allcoupondata.find(
        (c) =>
          c.couponCode === code &&
          (c.planid === planName || c.planid === selectedPlan?.id)
      );

      if (!found) {
        setCouponError("❌ Invalid Coupon Code or Plan Mismatch");
        setCouponApplied(false);
        return;
      }

      setCouponError("");
      setCouponApplied(true);
    } catch (error) {
      console.log("applyCoupon error:", error);
      setCouponError("❌ Failed to apply coupon");
      setCouponApplied(false);
    }
  };

  const handleSubscriptionPayment = async () => {
    try {
      if (!userData?._id) {
        alert("Please login first");
        return;
      }

      if (!selectedPlan?.id) {
        alert("Plan id missing");
        return;
      }

      if (!razorpayKeyId) {
        alert("Razorpay key missing");
        return;
      }

      setProcessing(true);

      const scriptLoaded = await loadRazorpayScriptOnce();

      if (!scriptLoaded) {
        alert("Failed to load Razorpay Checkout");
        setProcessing(false);
        return;
      }

      const createSubRes = await axios.post(
        `${PAYMENT_BASE}/api/payment/subscriptions/create`,
        {
          planId: selectedPlan.id,
          userId: userData._id,
          couponCode: couponApplied ? (searchvalue || "").trim() : "",
          totalCount: 12,
          quantity: 1,
        }
      );

      const subscriptionId = createSubRes?.data?.subscriptionId;
      const keyIdFromServer = createSubRes?.data?.keyId || razorpayKeyId;

      if (!subscriptionId) {
        alert("Failed to create subscription");
        setProcessing(false);
        return;
      }

      const options = {
        key: keyIdFromServer,
        subscription_id: subscriptionId,
        name: "Subscription Plan",
        description: selectedPlan?.item?.name || "Plan Subscription",
        image: "",
        handler: async function (response) {
          try {
            const verifyRes = await axios.post(
              `${PAYMENT_BASE}/api/payment/subscriptions/verify`,
              {
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_subscription_id: response.razorpay_subscription_id,
                razorpay_signature: response.razorpay_signature,
                userId: userData?._id,
                planId: selectedPlan?.id,
                couponCode: couponApplied ? (searchvalue || "").trim() : "",
              }
            );

            if (verifyRes?.status === 200 && verifyRes?.data?.success) {
              alert("Subscription activated successfully");
              handleClose();
              window.location.assign("/payment-success");
            } else {
              alert("Subscription verification failed");
            }
          } catch (error) {
            console.log("subscription verify error:", error);
            alert(
              error?.response?.data?.message || "Subscription verification failed"
            );
          } finally {
            setProcessing(false);
          }
        },
        prefill: {
          name: userData?.username || userData?.name || "Customer",
          email: userData?.email || "",
          contact: userData?.phoneNumber || "",
        },
        notes: {
          userId: userData?._id || "",
          planId: selectedPlan?.id || "",
        },
        theme: {
          color: "#23408B",
        },
        modal: {
          ondismiss: function () {
            try {
              setProcessing(false);
            } catch (error) {
              console.log("razorpay modal dismiss error:", error);
            }
          },
        },
      };

      const rzp = new window.Razorpay(options);

      rzp.on("payment.failed", function (response) {
        try {
          console.log("payment failed:", response);
          alert(
            response?.error?.description || "Payment failed. Please try again."
          );
          setProcessing(false);
        } catch (error) {
          console.log("payment.failed error:", error);
          setProcessing(false);
        }
      });

      rzp.open();
    } catch (error) {
      console.log("handleSubscriptionPayment error:", error);
      alert(error?.response?.data?.message || "Failed to start subscription");
      setProcessing(false);
    }
  };

  return (
    <div
      style={{
        fontFamily: "Poppins, sans-serif",
        background: "#F6F8FF",
        minHeight: "100vh",
        padding: "18px 0",
      }}
    >
      <div className="container" style={{ maxWidth: "980px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            marginBottom: "14px",
          }}
        >
          <div>
            <div
              style={{
                fontSize: "14px",
                fontWeight: 700,
                color: "#0F172A",
                lineHeight: 1.2,
              }}
            >
              Subscription Plans
            </div>
            <div style={{ fontSize: "13px", color: "#64748B", marginTop: "4px" }}>
              Choose a plan that fits your needs
            </div>
          </div>

          <button
            onClick={fetchAllPlanData}
            className="btn"
            style={{
              fontSize: "13px",
              fontWeight: 600,
              borderRadius: "10px",
              padding: "10px 12px",
              background: "#EEF2FF",
              color: "#1D4ED8",
              border: "1px solid rgba(29, 78, 216, 0.18)",
            }}
          >
            {loading ? "Refreshing..." : "Refresh"}
          </button>
        </div>

        {errMsg ? (
          <div
            style={{
              border: "1px solid rgba(239, 68, 68, 0.25)",
              background: "rgba(239, 68, 68, 0.06)",
              borderRadius: "12px",
              padding: "12px",
              marginBottom: "14px",
              fontSize: "13px",
              color: "#991B1B",
              fontWeight: 600,
            }}
          >
            {errMsg}
          </div>
        ) : null}

        {loading ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "14px",
            }}
          >
            {Array.from({ length: 1 }).map((_, i) => (
              <div
                key={i}
                style={{
                  borderRadius: "16px",
                  background: "#FFFFFF",
                  border: "1px solid rgba(15, 23, 42, 0.08)",
                  padding: "14px",
                  boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
                }}
              >
                <div
                  style={{
                    height: "14px",
                    width: "65%",
                    borderRadius: "8px",
                    background: "rgba(15, 23, 42, 0.08)",
                    marginBottom: "10px",
                  }}
                />
                <div
                  style={{
                    height: "11px",
                    width: "40%",
                    borderRadius: "8px",
                    background: "rgba(15, 23, 42, 0.07)",
                    marginBottom: "14px",
                  }}
                />
                <div
                  style={{
                    height: "36px",
                    width: "100%",
                    borderRadius: "12px",
                    background: "rgba(15, 23, 42, 0.06)",
                  }}
                />
              </div>
            ))}
          </div>
        ) : null}

        {!loading && allplandata.length === 0 ? (
          <div
            style={{
              borderRadius: "16px",
              background: "#FFFFFF",
              border: "1px solid rgba(15, 23, 42, 0.08)",
              padding: "18px",
              textAlign: "center",
              fontSize: "13px",
              color: "#64748B",
            }}
          >
            No plans found.
          </div>
        ) : null}

        {!loading && allplandata?.length > 0 ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: "14px",
            }}
          >
            {allplandata.map((plan, idx) => {
              try {
                const name = plan?.item?.name || "Plan";
                const desc =
                  plan?.item?.description ||
                  plan?.notes?.plan_name ||
                  "Subscription plan";
                const price = formatINR(plan?.item?.amount);
                const per = plan?.period || "monthly";
                const interval = plan?.interval || 1;

                return (
                  <div
                    key={`${plan?.id}-${idx}`}
                    style={{
                      borderRadius: "18px",
                      background: "#FFFFFF",
                      border: "1px solid rgba(15, 23, 42, 0.08)",
                      padding: "14px",
                      boxShadow: "0 12px 35px rgba(15, 23, 42, 0.08)",
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        height: "4px",
                        background:
                          "linear-gradient(90deg, #4B7BEC 0%, #22C55E 100%)",
                      }}
                    />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "10px",
                        alignItems: "flex-start",
                        marginTop: "6px",
                      }}
                    >
                      <div style={{ minWidth: 0 }}>
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: 800,
                            color: "#0F172A",
                            letterSpacing: "0.2px",
                            textTransform: "uppercase",
                          }}
                        >
                          {name}
                        </div>
                        <div
                          style={{
                            fontSize: "13px",
                            color: "#64748B",
                            marginTop: "6px",
                            lineHeight: 1.35,
                          }}
                        >
                          {desc}
                        </div>
                      </div>

                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 700,
                          color: "#1D4ED8",
                          background: "rgba(29, 78, 216, 0.10)",
                          padding: "6px 10px",
                          borderRadius: "999px",
                          border: "1px solid rgba(29, 78, 216, 0.15)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {interval} {per}
                      </span>
                    </div>

                    <div style={{ marginTop: "12px" }}>
                      <div
                        style={{
                          fontSize: "13px",
                          color: "#64748B",
                          fontWeight: 600,
                        }}
                      >
                        Price
                      </div>
                      <div
                        style={{
                          marginTop: "4px",
                          display: "flex",
                          alignItems: "baseline",
                          gap: "8px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "18px",
                            fontWeight: 900,
                            color: "#0F172A",
                          }}
                        >
                          {price}
                        </div>
                        <div style={{ fontSize: "13px", color: "#64748B" }}>
                          / {per}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "10px",
                        marginTop: "12px",
                        padding: "12px",
                        borderRadius: "14px",
                        background: "#F8FAFF",
                        border: "1px solid rgba(15, 23, 42, 0.06)",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#64748B",
                            fontWeight: 700,
                          }}
                        >
                          Currency
                        </div>
                        <div
                          style={{
                            fontSize: "13px",
                            color: "#0F172A",
                            fontWeight: 700,
                            marginTop: "2px",
                          }}
                        >
                          {plan?.item?.currency || "INR"}
                        </div>
                      </div>

                      <div>
                        <div
                          style={{
                            fontSize: "12px",
                            color: "#64748B",
                            fontWeight: 700,
                          }}
                        >
                          Status
                        </div>
                        <div
                          style={{
                            fontSize: "13px",
                            color: plan?.item?.active ? "#16A34A" : "#DC2626",
                            fontWeight: 800,
                            marginTop: "2px",
                          }}
                        >
                          {plan?.item?.active ? "Active" : "Inactive"}
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={() => onSubscribe(plan)}
                      className="btn"
                      style={{
                        width: "100%",
                        borderRadius: "12px",
                        fontSize: "14px",
                        fontWeight: 700,
                        padding: "11px",
                        marginTop: "12px",
                        background:
                          "linear-gradient(90deg, #4B7BEC 0%, #2B70D8 100%)",
                        color: "#fff",
                        border: "none",
                        boxShadow: "0 12px 30px rgba(75, 123, 236, 0.28)",
                      }}
                      disabled={!plan?.item?.active}
                    >
                      {plan?.item?.active ? "Subscribe Now" : "Not Available"}
                    </button>
                  </div>
                );
              } catch (error) {
                console.log("plan render error:", error);
                return null;
              }
            })}
          </div>
        ) : null}
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            className="poppins-semibold"
            style={{ fontSize: 18, fontWeight: 700 }}
          >
            Plan Details
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {couponError ? (
            <p
              style={{
                marginTop: 10,
                color: "#DC2626",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              {couponError}
            </p>
          ) : null}

          {!couponError && couponApplied ? (
            <p
              style={{
                marginTop: 10,
                color: "#16A34A",
                fontWeight: 600,
                textAlign: "center",
              }}
            >
              ✅ Coupon applied successfully
            </p>
          ) : null}

          <div
            className="poppins-semibold"
            style={{
              marginTop: 16,
              fontSize: 16,
              fontWeight: 800,
              color: "#16A34A",
            }}
          >
            Billing Details
          </div>

          <div style={{ marginTop: 10, fontSize: 14, color: "#0F172A" }}>
            <p className="poppins-regular" style={{ marginBottom: 6 }}>
              <strong>Plan Name:</strong> {selectedPlan?.item?.name}
            </p>
            <p className="poppins-regular" style={{ marginBottom: 6 }}>
              <strong>Period:</strong> {selectedPlan?.period} (interval{" "}
              {selectedPlan?.interval})
            </p>
            <p className="poppins-regular" style={{ marginBottom: 6 }}>
              <strong>Recurring Price:</strong> {formatINR(selectedPlanAmountPaise)}
            </p>
            <p className="poppins-regular" style={{ marginBottom: 0 }}>
              <strong>Auto Debit:</strong> Enabled after authorization payment
            </p>
            <p className="poppins-regular" style={{ marginBottom: 0 }}>
              <strong>Search count:</strong>{" "}
              {selectedPlan?.period === "weekly"
                ? "20"
                : selectedPlan?.period === "monthly"
                  ? "500"
                  : "0"}
            </p>
          </div>

          <div
            className="poppins-regular"
            style={{
              marginTop: 14,
              borderRadius: "12px",
              padding: "12px",
              background: "#FFF7ED",
              border: "1px solid rgba(249, 115, 22, 0.18)",
              color: "#9A3412",
              fontSize: "13px",
              fontWeight: 600,
              lineHeight: 1.5,
            }}
          >
            Note: This is an auto-debit subscription. Razorpay will charge the
            plan amount as per the billing cycle after authorization.
          </div>


        </Modal.Body>

        <Modal.Footer>
          <div
            className="poppins-regular"
            style={{
              backgroundColor: "grey",
              color: "white",
              padding: "8px 14px",
              textAlign: "center",
              borderRadius: "5px",
              cursor: processing ? "not-allowed" : "pointer",
              opacity: processing ? 0.7 : 1,
            }}
            onClick={() => {
              try {
                if (!processing) {
                  handleClose();
                }
              } catch (error) {
                console.log("close button error:", error);
              }
            }}
          >
            Close
          </div>

          <div
            onClick={() => {
              try {
                if (!processing) {
                  handleSubscriptionPayment();
                }
              } catch (error) {
                console.log("pay button error:", error);
              }
            }}
            className="poppins-regular"
            style={{
              backgroundColor: "blue",
              color: "white",
              padding: "8px 14px",
              textAlign: "center",
              borderRadius: "5px",
              cursor: processing ? "not-allowed" : "pointer",
              opacity: processing ? 0.7 : 1,
            }}
          >
            {processing ? "Processing..." : "Pay & Subscribe"}
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Planone;
